// -----------------------------------------------------------------------------
// firestoreErrors — Helper pour gérer les erreurs Firestore proprement
// StockPro / VisualisPro
// -----------------------------------------------------------------------------

/**
 * Convertit un code d'erreur Firestore en message utilisateur lisible.
 * @param {Error} error - L'erreur Firestore
 * @returns {string} Message lisible pour l'utilisateur
 */
export function getFirestoreErrorMessage(error) {
  if (!error) return "Erreur inconnue";

  const code = error.code || "";

  // Erreurs de permission (Firestore Rules)
  if (code === "permission-denied") {
    return "Accès refusé. Vérifiez votre licence ou contactez le support.";
  }

  // Erreurs réseau / connectivité
  if (code === "unavailable" || code === "deadline-exceeded") {
    return "Connexion perdue. Vos modifications seront synchronisées dès le retour en ligne.";
  }

  // Erreur d'authentification
  if (code === "unauthenticated") {
    return "Session expirée. Veuillez vous reconnecter.";
  }

  // Quota dépassé
  if (code === "resource-exhausted") {
    return "Quota dépassé. Contactez VisualisPro.";
  }

  // Document introuvable
  if (code === "not-found") {
    return "Élément introuvable. Il a peut-être été supprimé.";
  }

  // Conflit (déjà existant)
  if (code === "already-exists") {
    return "Cet élément existe déjà.";
  }

  // Données invalides
  if (code === "invalid-argument" || code === "failed-precondition") {
    return "Données invalides. Vérifiez les informations saisies.";
  }

  // Fallback générique
  return "Erreur de synchronisation. Réessayez dans un instant.";
}

/**
 * Logue une erreur Firestore dans la console avec un contexte clair.
 * @param {string} action - Description de l'action qui a échoué (ex: "updateQty")
 * @param {Error} error - L'erreur Firestore
 * @param {object} [extra] - Données contextuelles supplémentaires
 */
export function logFirestoreError(action, error, extra = {}) {
  console.error(
    `[Firestore] ${action} failed:`,
    {
      code: error?.code || "unknown",
      message: error?.message || String(error),
      ...extra,
    }
  );
}
